export default __webpack_public_path__ + "static/media/chooose-blush.bf0277a4.svg";